<template>
  <section class="section-base form-section-base">
    <v-container>
      <div class="form-base">
        <v-row>
          <v-col>
            <div class="form-base__title">
              {{ Text.refusalDetailsTitle }}
            </div>
          </v-col>
        </v-row>

        <BankDetails :v="$v.accountBankDetails" />

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="transferElDocsDetails.hasPrivilege"
              label="Наличие льготы"
              hide-details
            />
          </v-col>
          <v-col v-if="transferElDocsDetails.hasPrivilege" cols="12">
            <v-textarea
              v-model="$v.transferElDocsDetails.note.$model"
              :errorMessages="
                getValidationErrorText($v.transferElDocsDetails.note)
              "
              outlined
              label="Примечание (основание для льготы, при наличии)"
            />
            <span class="text-small-size">
              {{ Text.hasPrivilegeNote }}
            </span>
          </v-col>
        </v-row>
      </div>

      <Footer
        @next-btn-click="btnSaveClickHandler(StepDirection.NEXT)"
        @prev-btn-click="btnSaveClickHandler(StepDirection.PREV)"
        :loading-next="loadingNext"
      />
    </v-container>
  </section>
</template>

<script>
import { maxLength, requiredIf } from 'vuelidate/lib/validators';

import { getValidationErrorText, EMOJI } from '@/utils/validate';
import { checkInvalid, Text, leaveStep } from '@/utils/services';
import { ServicesModule } from '@/store/modules/services';
import Footer from '@/components/services/elements/Footer';
import { StepDirection, StepName } from '@/types/services';
import BankDetails, {
  bankDetails,
  bankDetailsValidation,
} from '@/components/services/elements/BankDetails';
import { TransferElDocsStep } from '@/constants';

export default {
  name: 'AccountBankDetails',
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Footer,
    BankDetails,
  },
  data: () => ({
    Text,
    StepDirection,
    StepName,
    leaveStep,
    getValidationErrorText,
    invalidFields: [],
    accountBankDetails: { ...bankDetails },
    transferElDocsDetails: {
      hasPrivilege: false,
      note: '',
    },
  }),
  validations() {
    return {
      accountBankDetails: bankDetailsValidation,
      transferElDocsDetails: {
        note: {
          required: requiredIf(() => this.transferElDocsDetails.hasPrivilege),
          maxLength: maxLength(4000),
          EMOJI,
        },
      },
    };
  },
  created() {
    this.prefillDraft();
  },
  methods: {
    prefillDraft() {
      const SABD = ServicesModule.statement.accountBankDetails;
      const STEDD = ServicesModule.statement.transferElDocsDetails;

      if (SABD) {
        this.accountBankDetails = { ...this.accountBankDetails, ...SABD };
      }

      if (STEDD) {
        this.transferElDocsDetails = {
          ...this.transferElDocsDetails,
          ...STEDD,
        };
      }
    },

    assemblyModel() {
      if (!this.transferElDocsDetails.hasPrivilege) {
        this.transferElDocsDetails.note = null;
      }

      return {
        accountBankDetails: {
          ...this.accountBankDetails,
        },
        transferElDocsDetails: {
          ...this.transferElDocsDetails,
        },
      };
    },

    touchFields() {
      this.invalidFields = [];

      this.$v.$touch();
      checkInvalid(this.$v, this.invalidFields);
    },

    btnSaveClickHandler(direction) {
      leaveStep({
        stepThis: this,
        direction,
        step: TransferElDocsStep.BANK_DETAILS,
      });
    },
  },
};
</script>
